module.exports = __webpack_public_path__ + "img/rr_logo.d17b9c8b.png";